module.exports = __webpack_public_path__ + "img/indu_active_13.b8c2be09.png";